module.exports = __webpack_public_path__ + "static/media/angle-double-right.6698ffe6.svg";